"use client";

import { create } from "zustand";
import { Dialog, DialogContent, DialogTitle } from "@gerama/ui";
import { useSiteAuthStore } from "@gerama/stores";
import { AuthFlow } from "./auth-flow";

/** One login dialog for the whole site. Opening it does not leave the page. */
export const useLoginModal = create<{ open: boolean; show: () => void; hide: () => void }>((set) => ({
  open: false,
  show: () => set({ open: true }),
  hide: () => set({ open: false }),
}));

export function openLogin() {
  useLoginModal.getState().show();
}

/** True when a session exists. Otherwise opens the login dialog and returns false. */
export function requireAuth(): boolean {
  if (useSiteAuthStore.getState().token) return true;
  openLogin();
  return false;
}

export function LoginModal() {
  const open = useLoginModal((s) => s.open);
  const hide = useLoginModal((s) => s.hide);
  return (
    <Dialog open={open} onOpenChange={(next) => (next ? openLogin() : hide())}>
      <DialogContent className="sm:max-w-md">
        <DialogTitle className="sr-only">ورود و ثبت‌نام</DialogTitle>
        {open ? <AuthFlow embedded onSignedIn={hide} /> : null}
      </DialogContent>
    </Dialog>
  );
}
